// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__UHD5c","logo":"menu_logo__BurW3"};